<template>
 <div>
  <div ref="balanceWrapper">
    <!-- PC -->
    <div class="summary-wrapper pc">
      <div class="summary-item" >
        <div class="title">
          <span>{{ $t('message.index.overview') }}</span>
        </div>
        <div v-loading="loadingTxnSuccessRate" class="content">
          <template v-if="!loadingTxnSuccessRate">
            <div v-if="isUpgrading" class="success-temporary">{{ $t('message.index.Upgrading') }}</div>
            <line-chart v-else :options="txnSuccessRateChart" type="bar" :showXAxisLabels="[10, 20]">
              <div slot="title" class="overview-title">
                <span>{{ $t('message.index.transactionSuccessRate') }}</span>
              </div>
              <div slot="subtitle" class="overview-subtitle">
                <div>
                  <span class="date margin-right-15">{{ txnSuccessRateTitle.date }}</span>
                  <span class="data">{{ txnSuccessRateTitle.data }}</span>
                </div>
              </div>
            </line-chart>
          </template>
        </div>
      </div>
    </div>
    <!-- 手机端 -->
    <div class="summary-wrapper mobile">
      <div class="title">
        <span>{{ $t('message.index.overview') }}</span>
      </div>
      <div  v-loading="loadingTxnSuccessRate" class="content">
        <template v-if="!loadingTxnSuccessRate">
          <div v-if="isUpgrading" class="success-temporary">{{ $t('message.index.Upgrading') }}</div>
          <line-chart v-else :options="txnSuccessRateChart">
            <div slot="title" class="overview-title">
              <span>{{ $t('message.index.transactionSuccessRate') }}</span>
            </div>
            <div slot="subtitle" class="overview-subtitle">
              <div>
                <span class="date margin-right-15">{{ txnSuccessRateTitle.date }}</span>
                <span class="data">{{ txnSuccessRateTitle.data }}</span>
              </div>
            </div>
          </line-chart>
        </template>
      </div>
    </div>
    <!-- 拒付率 PC  -->
    <div v-loading="loadingRefuse" class="txn-wrapper refuse-wrapper pc">
      <div class="title-wrapper">
        <span class="title"></span>
        <el-select size="small" class="currency" v-model="refuseCurrency" @change="changeRefuseChartData" filterable>
          <template v-for="(currency, index) in refuseCurrencyList">
            <el-option :label="currency" :value="currency" :key="index"></el-option>
          </template>
        </el-select>
      </div>
      <div class="chart-wrapper">
        <div class="chart-box-wrapper margin-bottom-20">
          <!-- 拒付率 -->
          <div class="chart-item margin-right-20">
            <line-chart :options="refuseRateChart">
              <div slot="title" class="txn-title-wrapper">
                <div>
                  <span>{{ $t('message.index.refuseRate') }}</span>
                  <!-- <el-popover trigger="click" :content="$t('message.index.refuseRateTip')" class="i-popover">
                    <span class="iconfont icon-tishi003" slot="reference"></span>
                  </el-popover> -->
                </div>
                <span class="right">{{ refuseRateTitle.data }}</span>
              </div>
              <div slot="subtitle" class="txn-subtitle-wrapper">
                <span class="date">{{ refuseRateTitle.date }}</span>
                <span class="value">{{$t('message.index.refuseNumber')}}：{{refuseRateTitle.count}}</span>
              </div>
            </line-chart>
          </div>
          <!-- 退款率 -->
          <div class="chart-item">
            <line-chart :options="refundRateChart">
              <div slot="title" class="txn-title-wrapper">
                <div>
                  <span>{{ $t('message.index.refundRate') }}</span>
                  <!-- <el-popover trigger="click" :content="$t('message.index.refundRateTip')" class="i-popover">
                    <span class="iconfont icon-tishi003" slot="reference"></span>
                  </el-popover> -->
                </div>
                <span class="right">{{ refundRateTitle.data }}</span>
              </div>
              <div slot="subtitle" class="txn-subtitle-wrapper">
                <span class="date">{{ refundRateTitle.date }}</span>
                <span class="value">{{$t('message.tableCommon.refundAmount')}}：{{refundRateTitle.count}} {{ refuseCurrency === 'ALL' ? 'USD' : refuseCurrency }}</span>
              </div>
            </line-chart>
          </div>
        </div>
      </div>
    </div>
    <!-- 拒付率 移动端  -->
    <div v-loading="loadingRefuse" class="txn-wrapper refuse-wrapper mobile">
      <div class="title-wrapper">
        <span class="title"></span>
        <el-select size="small" class="currency" v-model="refuseCurrency" @change="changeRefuseChartData" filterable>
          <template v-for="(currency, index) in refuseCurrencyList">
            <el-option :label="currency" :value="currency" :key="index"></el-option>
          </template>
        </el-select>
      </div>
      <div class="chart-wrapper">
        <div class="margin-bottom-20">
          <!-- 拒付率 -->
          <div class="chart-item margin-bottom-20">
            <line-chart :options="refuseRateChart">
              <div slot="title" class="txn-title-wrapper">
                <div>
                  <span>{{ $t('message.index.refuseRate') }}</span>
                  <!-- <el-popover trigger="click" :content="$t('message.index.refuseRateTip')" class="i-popover">
                    <span class="iconfont icon-tishi003" slot="reference"></span>
                  </el-popover> -->
                </div>
                <span class="right">{{ refuseRateTitle.data }}%</span>
              </div>
              <div slot="subtitle" class="txn-subtitle-wrapper">
                <span class="date">{{ refuseRateTitle.date }}</span>
                <span class="value">{{$t('message.index.refuseNumber')}}：{{refuseRateTitle.count}}</span>
              </div>
            </line-chart>
          </div>
          <!-- 退款率 -->
          <div class="chart-item">
            <line-chart :options="refundRateChart">
              <div slot="title" class="txn-title-wrapper">
                <div>
                  <span>{{ $t('message.index.refundRate') }}</span>
                  <!-- <el-popover trigger="click" :content="$t('message.index.refundRateTip')" class="i-popover">
                    <span class="iconfont icon-tishi003" slot="reference"></span>
                  </el-popover> -->
                </div>
                <span class="right">{{ refundRateTitle.data }}%</span>
              </div>
              <div slot="subtitle" class="txn-subtitle-wrapper">
                <span class="date">{{ refundRateTitle.date }}</span>
                <span class="value">{{$t('message.tableCommon.refundAmount')}}：{{refundRateTitle.count}} {{ refuseCurrency === 'ALL' ? 'USD' : refuseCurrency }}</span>
              </div>
            </line-chart>
          </div>
        </div>
      </div>
    </div>
    <!-- PC -->
    <div v-loading="loading" class="txn-wrapper pc">
      <div class="title-wrapper">
        <span class="title">{{ $t('message.index.transaction') }}</span>
        <el-select size="small" class="currency" v-model="txn.currency" @change="changeTxnChartData" filterable>
          <!-- <el-option label="ALL" value="ALL"></el-option> -->
          <template v-for="(currency, index) in currencyList">
            <el-option :label="currency" :value="currency" :key="index"></el-option>
          </template>
        </el-select>
        <div class="interval-box">
          <template v-for="(date, index) in txnDateOptions">
            <div :key="index" class="interval-item" :class="{active: date.value === txn.dayCount}" @click="changeDayCountHandler(date.value)">{{$t(date.label)}}</div>
          </template>
        </div>
        <!-- <el-select size="small" class="time" v-model="txn.dayCount" @change="changeDayCountHandler" filterable>
          <template v-for="(date, index) in txnDateOptions">
            <el-option :key="index" :label="$t(date.label)" :value="date.value"></el-option>
          </template>
        </el-select> -->
      </div>
      <div class="chart-wrapper">
        <div class="chart-box-wrapper margin-bottom-20">
          <!-- 当前币种成功交易金额 -->
          <div class="chart-item margin-right-20">
            <line-chart :options="txnSuccessAmountChart">
              <div slot="title" class="txn-title-wrapper">
                <div>
                  <span>{{ $t('message.index.successTxnAmount') }}</span>
                  <el-popover :placement="'right'" trigger="click" :content="$t('message.index.successTxnAmountTip')" class="i-popover">
                    <span class="iconfont icon-tishi003" slot="reference"></span>
                  </el-popover>
                </div>
              </div>
              <div slot="subtitle" class="txn-subtitle-wrapper">
                <div>
                  <span class="amount">{{ txnChartTitle.successAmount.data }} {{ txn.currency === 'ALL' ? 'USD' : txn.currency }}</span>
                </div>
                <span class="date">{{ txnChartTitle.successAmount.date }}</span>
              </div>
            </line-chart>
          </div>
          <!-- 当前币种成功交易笔数 -->
          <div class="chart-item">
            <line-chart :options="txnSuccessCountChart">
              <div slot="title" class="txn-title-wrapper">
                <div>
                  <span>{{ $t('message.index.successTxnCount') }}</span>
                  <el-popover :placement="'right'" trigger="click" :content="$t('message.index.successTxnCountTip')" class="i-popover">
                    <span class="iconfont icon-tishi003" slot="reference"></span>
                  </el-popover>
                </div>
              </div>
              <div slot="subtitle" class="txn-subtitle-wrapper">
                <div>
                  <span class="amount">{{ txnChartTitle.successCount.data }}</span>
                </div>
                <span class="date">{{ txnChartTitle.successCount.date }}</span>
              </div>
            </line-chart>
          </div>
        </div>
        <div class="chart-box-wrapper">
          <!-- 当前币种拒付交易金额 -->
          <div class="chart-item margin-right-20">
            <line-chart :options="chargebackAmountChart">
              <div slot="title" class="txn-title-wrapper">
                <div>
                  <span>{{ $t('message.index.chargebackAmount') }}</span>
                  <el-popover :placement="'right'" trigger="click" :content="$t('message.index.chargebackAmountTip')" class="i-popover">
                    <span class="iconfont icon-tishi003" slot="reference"></span>
                  </el-popover>
                </div>
              </div>
              <div slot="subtitle" class="txn-subtitle-wrapper">
                <div>
                  <span class="amount">{{ txnChartTitle.chargebackAmount.data }} {{ txn.currency === 'ALL' ? 'USD' : txn.currency }}</span>
                </div>
                <span class="date">{{ txnChartTitle.chargebackAmount.date }}</span>
              </div>
            </line-chart>
          </div>
          <!-- 当前币种拒付交易笔数 -->
          <div class="chart-item">
            <line-chart :options="chargebackCountChart">
              <div slot="title" class="txn-title-wrapper">
                <div>
                  <span>{{ $t('message.index.refuseCount') }}</span>
                  <el-popover :placement="'right'" trigger="click" :content="$t('message.index.refuseCountTip')" class="i-popover">
                    <span class="iconfont icon-tishi003" slot="reference"></span>
                  </el-popover>
                </div>
              </div>
              <div slot="subtitle" class="txn-subtitle-wrapper">
                <div>
                  <span class="amount">{{ txnChartTitle.chargebackCount.data }}</span>
                </div>
                <span class="date">{{ txnChartTitle.chargebackCount.date }}</span>
              </div>
            </line-chart>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机端 -->
    <div v-loading="loading" class="txn-wrapper mobile">
      <div class="title-wrapper">
        <span class="title">{{ $t('message.index.transaction') }}</span>
        <div class="title-wrapper-right">
          <div class="interval-box">
            <template v-for="(date, index) in txnDateOptions">
              <div :key="index" class="interval-item" :class="{active: date.value === txn.dayCount}" @click="changeDayCountHandler(date.value)">{{$t(date.label)}}</div>
            </template>
          </div>
          <el-select
            v-if="mobileChart.tab !== 1 || mobileChart.subTab !== 3"
            style="margin-right:0px;"
            size="small"
            class="currency margin-left-20"
            v-model="txn.currency"
            @change="changeTxnChartData"
            filterable>
            <!-- <el-option label="ALL" value="ALL"></el-option> -->
            <template v-for="(currency, index) in currencyList">
              <el-option :label="currency" :value="currency" :key="index"></el-option>
            </template>
          </el-select>
        </div>
      </div>
      <div class="tabs">
        <div @click="changeMobileTab(1)" class="tab" :class="{active: mobileChart.tab === 1}">{{ $t('message.index.successTxn') }}</div>
        <div @click="changeMobileTab(2)" class="tab" :class="{active: mobileChart.tab === 2}">{{ $t('message.index.refuseTxt') }}</div>
      </div>
      <div class="sub-tab-btns">
        <el-button @click="changeMobileSubTab(1)" type="text" class="btn" :class="{active: mobileChart.subTab === 1}">{{ $t('message.index.amount') }}</el-button>
        <el-button @click="changeMobileSubTab(2)" type="text" class="btn" :class="{active: mobileChart.subTab === 2}">{{ $t('message.index.count') }}</el-button>
      </div>
      <div class="chart-box chart-wrapper">
        <!-- 当前币种成功交易笔数 -->
        <line-chart :options="txnSuccessCountChart" height="100%" v-if="mobileChart.tab === 1 && mobileChart.subTab === 2">
          <div slot="title" class="txn-title-wrapper">
            <div>
              <span>{{ $t('message.index.successTxnCount') }}</span>
              <el-popover :placement="'right'" trigger="click" :content="$t('message.index.successTxnCountTip')" class="i-popover">
                <span class="iconfont icon-tishi003" slot="reference"></span>
              </el-popover>
            </div>
          </div>
          <div slot="subtitle" class="txn-subtitle-wrapper">
            <div>
              <span class="amount">{{ txnChartTitle.successCount.data }}</span>
            </div>
            <span class="date">{{ txnChartTitle.successCount.date }}</span>
          </div>
        </line-chart>
        <!-- 当前币种成功交易金额 -->
        <line-chart :options="txnSuccessAmountChart" height="100%" v-if="mobileChart.tab === 1 && mobileChart.subTab === 1">
          <div slot="title" class="txn-title-wrapper">
            <div>
              <span>{{ $t('message.index.successTxnAmount') }}</span>
              <el-popover :placement="'right'" trigger="click" :content="$t('message.index.successTxnAmountTip')" class="i-popover">
                <span class="iconfont icon-tishi003" slot="reference"></span>
              </el-popover>
            </div>
          </div>
          <div slot="subtitle" class="txn-subtitle-wrapper">
            <div>
              <span class="amount">{{ txnChartTitle.successAmount.data }} {{ txn.currency === 'ALL' ? 'USD' : txn.currency }}</span>
            </div>
            <span class="date">{{ txnChartTitle.successAmount.date }}</span>
          </div>
        </line-chart>
        <!-- 当前币种拒付交易笔数 -->
        <line-chart :options="chargebackCountChart" height="100%" v-if="mobileChart.tab === 2 && mobileChart.subTab === 2">
          <div slot="title" class="txn-title-wrapper">
            <div>
              <span>{{ $t('message.index.refuseCount') }}</span>
              <el-popover :placement="'right'" trigger="click" :content="$t('message.index.refuseCountTip')" class="i-popover">
                <span class="iconfont icon-tishi003" slot="reference"></span>
              </el-popover>
            </div>
          </div>
          <div slot="subtitle" class="txn-subtitle-wrapper">
            <div>
              <span class="amount">{{ txnChartTitle.chargebackCount.data }}</span>
            </div>
            <span class="date">{{ txnChartTitle.chargebackCount.date }}</span>
          </div>
        </line-chart>
        <!-- 当前币种拒付交易金额 -->
        <line-chart :options="chargebackAmountChart" height="100%" v-if="mobileChart.tab === 2 && mobileChart.subTab === 1">
          <div slot="title" class="txn-title-wrapper">
            <div>
              <span>{{ $t('message.index.chargebackAmount') }}</span>
              <el-popover :placement="'right'" trigger="click" :content="$t('message.index.chargebackAmountTip')" class="i-popover">
                <span class="iconfont icon-tishi003" slot="reference"></span>
              </el-popover>
            </div>
          </div>
          <div slot="subtitle" class="txn-subtitle-wrapper">
            <div>
              <span class="amount">{{ txnChartTitle.chargebackAmount.data }} {{ txn.currency === 'ALL' ? 'USD' : txn.currency }}</span>
            </div>
            <span class="date">{{ txnChartTitle.chargebackAmount.date }}</span>
          </div>
        </line-chart>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import LineChart from '@/components/chart/line-chart/index.vue';
import { ShowErrorMessage } from '@/components/modal/tips/message-tips';
import { formatMoney } from '@/utils/tools/constant';
import { getCurrencyImage } from '@/utils/tools/currency';
import { getChartDate, getTodayParams } from '@/utils/tools/time';
import {
  getCurrencyList, getTxnStatistics, getTxnSuccessRate,
  getWeekTxnStatistics, getMonthTxnStatistics, getRefuseCurrencyList,
  getRateInfoData,
} from '@/views/index/api/index';

export default {
  components: { LineChart },
  data() {
    return {
      loading: false,
      currencyList: [],
      txnSuccessRateChart: { // 交易成功率
        calculable: true,
        tooltip: {
          formatter: (params) => {
            this.txnSuccessRateClickHandler(params[0]);
            return '';
          },
        },
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: [],
          },
        ],
      },
      txnSuccessRateTitle: {
        date: '',
        data: '',
      },
      txnSuccessAmountChart: { // 成功交易金额
        calculable: true,
        tooltip: {
          formatter: (params) => {
            this.txnChartClickHandler(params[0]);
            return '';
          },
        },
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: [],
          },
        ],
      },
      txnSuccessCountChart: { // 成功交易笔数
        calculable: true,
        tooltip: {
          formatter: (params) => {
            this.txnChartClickHandler(params[0]);
            return '';
          },
        },
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: [],
          },
        ],
      },
      chargebackAmountChart: { // 拒付交易金额
        calculable: true,
        tooltip: {
          formatter: (params) => {
            this.txnChartClickHandler(params[0]);
            return '';
          },
        },
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: [],
          },
        ],
      },
      chargebackCountChart: { // 拒付交易笔数
        calculable: true,
        tooltip: {
          formatter: (params) => {
            this.txnChartClickHandler(params[0]);
            return '';
          },
        },
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: [],
          },
        ],
      },
      txnChartTitle: {
        successAmount: { date: '', data: '' },
        successCount: { date: '', data: '' },
        chargebackAmount: { date: '', data: '' },
        chargebackCount: { date: '', data: '' },
      },
      txnDateOptions: [
        { label: 'message.index.day', value: 1 },
        { label: 'message.index.week', value: 7 },
        { label: 'message.index.month', value: 30 },
      ],
      txn: { // 交易突变参数
        currency: 'ALL',
        dayCount: 1,
      },
      mobileChart: {
        tab: 1,
        subTab: 1,
      },
      screenWidth: window.screen.width,
      loadingTxnSuccessRate: true,
      refuseCurrencyList: [],
      refuseCurrency: 'ALL',
      refuseRateChart: { // 拒付交易笔数
        calculable: true,
        tooltip: {
          formatter: (params) => {
            this.refuseRateChartClickHandler(params[0]);
            return '';
          },
        },
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: [],
          },
        ],
      },
      refundRateChart: {
        calculable: true,
        tooltip: {
          formatter: (params) => {
            this.refundRateChartClickHandler(params[0]);
            return '';
          },
        },
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: [],
          },
        ],
      },
      refuseRateTitle: {
        date: '',
        data: '',
        count: '',
      },
      refundRateTitle: {
        date: '',
        data: '',
        count: '',
      },
      loadingRefuse: false,
    };
  },
  created() {
    // 交易成功率
    this.getTxnSuccessRateData();
    // 交易图标币种列表
    getCurrencyList({ dayCount: 30, indexTableType: 0 }).then((res) => {
      this.currencyList = res;
    });
    this.getTxnStatisticsData({ type: 0, ...this.txn });
    this.getTxnStatisticsData({ type: 1, ...this.txn });

    // 拒付率/退款率显示币种列表
    getRefuseCurrencyList().then(res => {
      this.refuseCurrencyList = res.map(item => item.value);
    });
    this.changeRefuseChartData();
  },
  mounted() {
  },
  methods: {
    getCurrencyImage,
    txnSuccessRateClickHandler(data) {
      this.txnSuccessRateChart.series[0].markPoint.data = [{ coord: [data.name, data.value] }];
      this.txnSuccessRateChart.series[0].data = [...this.txnSuccessRateChart.series[0].data]; // 触发表单刷新
      this.txnSuccessRateTitle.date = data.name;
      this.txnSuccessRateTitle.data = `${(data.value * 100).toFixed(2)}%`;
    },
    txnChartClickHandler(data) {
      const index = data.dataIndex;
      // 交易金额
      this.txnSuccessAmountChart.series[0].markPoint.data = [{ coord: [this.txnSuccessAmountChart.xAxis.data[index], this.txnSuccessAmountChart.series[0].data[index]] }];
      this.txnSuccessAmountChart.series[0].data = [...this.txnSuccessAmountChart.series[0].data];
      this.txnChartTitle.successAmount.date = this.txnSuccessAmountChart.xAxis.data[index];
      this.txnChartTitle.successAmount.data = formatMoney(this.txnSuccessAmountChart.series[0].data[index]);
      // 交易笔数
      this.txnSuccessCountChart.series[0].markPoint.data = [{ coord: [this.txnSuccessCountChart.xAxis.data[index], this.txnSuccessCountChart.series[0].data[index]] }];
      this.txnSuccessCountChart.series[0].data = [...this.txnSuccessCountChart.series[0].data];
      this.txnChartTitle.successCount.date = this.txnSuccessCountChart.xAxis.data[index];
      this.txnChartTitle.successCount.data = this.txnSuccessCountChart.series[0].data[index];
      // 拒付金额
      this.chargebackAmountChart.series[0].markPoint.data = [{ coord: [this.chargebackAmountChart.xAxis.data[index], this.chargebackAmountChart.series[0].data[index]] }];
      this.chargebackAmountChart.series[0].data = [...this.chargebackAmountChart.series[0].data];
      this.txnChartTitle.chargebackAmount.date = this.chargebackAmountChart.xAxis.data[index];
      this.txnChartTitle.chargebackAmount.data = formatMoney(this.chargebackAmountChart.series[0].data[index]);
      // 拒付笔数
      this.chargebackCountChart.series[0].markPoint.data = [{ coord: [this.chargebackCountChart.xAxis.data[index], this.chargebackCountChart.series[0].data[index]] }];
      this.chargebackCountChart.series[0].data = [...this.chargebackCountChart.series[0].data];
      this.txnChartTitle.chargebackCount.date = this.chargebackCountChart.xAxis.data[index];
      this.txnChartTitle.chargebackCount.data = this.chargebackCountChart.series[0].data[index];
    },
    async changeDayCountHandler(value) { // 日期切换，币种列表页更新
      if (value === this.txn.dayCount) {
        return;
      }
      this.txn.dayCount = value;
      this.loading = true;
      // const this.txn.dayCount
      let indexTableType = 0;
      if (this.txn.dayCount === 7) {
        indexTableType = 1;
      } else if (this.txn.dayCount === 30) {
        indexTableType = 2;
      }
      await getCurrencyList({ dayCount: 30, indexTableType }).then((res) => {
        this.currencyList = res;
        if (this.currencyList.length === 0) {
          this.txn.currency = 'ALL';
        } else {
          let existCurency = false;
          for (let i = 0; i < res.length; i++) {
            if (res[i].currency === this.txn.currency) {
              existCurency = true;
              break;
            }
          }
          if (!existCurency) {
            this.txn.currency = 'ALL';
          }
        }
      });
      this.changeTxnChartData();
    },
    async changeTxnChartData() {
      this.loading = true;
      try {
        await Promise.all([this.getTxnStatisticsData({ type: 0, ...this.txn }), this.getTxnStatisticsData({ type: 1, ...this.txn })]);
      } catch (err) {
        //
      }
      this.loading = false;
    },
    async getTxnStatisticsData(params) {
      // params.type {0: 交易, 1: 拒付}
      let MethodSub = getTxnStatistics;
      const data = {
        type: params.type,
        currency: params.currency,
        dayCount: 30,
      };
      if (params.dayCount === 1) { // 日
        data.dayCount = 30;
      } else if (params.dayCount === 7) { // 周
        MethodSub = getWeekTxnStatistics;
      } else if (params.dayCount === 30) { // 月
        MethodSub = getMonthTxnStatistics;
      }
      await MethodSub(data).then((res) => {
        // 交易
        if (params.type === 0) {
          const dates = Object.keys(res);
          const txnSuccessAmount = [];
          const txnSuccessCount = [];
          this.txnSuccessAmountChart.xAxis.data = dates;
          this.txnSuccessCountChart.xAxis.data = dates;
          for (let i = 0; i < dates.length; i++) {
            const item = res[dates[i]];
            txnSuccessAmount.push(item.amount);
            txnSuccessCount.push(item.count);
          }

          const lastDate = dates[dates.length - 1];
          // 成功交易金额
          this.txnSuccessAmountChart.series[0].markPoint = { data: [{ coord: [lastDate, res[lastDate].amount] }] };
          this.txnSuccessAmountChart.series[0].data = txnSuccessAmount;
          this.txnChartTitle.successAmount.data = `${formatMoney(res[lastDate].amount)}`;
          this.txnChartTitle.successAmount.date = lastDate;
          // 成功交易笔数
          this.txnSuccessCountChart.series[0].markPoint = { data: [{ coord: [lastDate, res[lastDate].count] }] };
          this.txnSuccessCountChart.series[0].data = txnSuccessCount;
          this.txnChartTitle.successCount.data = res[lastDate].count;
          this.txnChartTitle.successCount.date = lastDate;
        }
        // 拒付
        if (params.type === 1) {
          const dates = Object.keys(res);
          const chargebackAmount = [];
          const chargebackCount = [];
          this.chargebackAmountChart.xAxis.data = dates;
          this.chargebackCountChart.xAxis.data = dates;
          for (let i = 0; i < dates.length; i++) {
            const item = res[dates[i]];
            chargebackAmount.push(item.amount);
            chargebackCount.push(item.count);
          }
          const lastDate = dates[dates.length - 1];
          // 拒付金额
          this.chargebackAmountChart.series[0].markPoint = { data: [{ coord: [lastDate, res[lastDate].amount] }] };
          this.chargebackAmountChart.series[0].data = chargebackAmount;
          this.txnChartTitle.chargebackAmount.data = `${formatMoney(res[lastDate].amount)}`;
          this.txnChartTitle.chargebackAmount.date = lastDate;
          // 拒付笔数
          this.chargebackCountChart.series[0].markPoint = { data: [{ coord: [lastDate, res[lastDate].count] }] };
          this.chargebackCountChart.series[0].data = chargebackCount;
          this.txnChartTitle.chargebackCount.data = res[lastDate].count;
          this.txnChartTitle.chargebackCount.date = lastDate;
        }
      });
    },
    // 交易成功率
    getTxnSuccessRateData() {
      getTxnSuccessRate().then((res) => {
        const allDate = Object.keys(res);
        let showDate = allDate;
        // 手机端截取最近7天数据
        if (this.screenWidth < 992) {
          showDate = allDate.slice(allDate.length - 7, allDate.length);
        }
        this.txnSuccessRateChart.xAxis.data = showDate;
        const successRateChartData = [];
        this.txnSuccessRateChart.xAxis.data.forEach((item) => {
          successRateChartData.push(res[item]);
        });
        this.txnSuccessRateChart.series[0].data = successRateChartData;
        const lastDate = this.txnSuccessRateChart.xAxis.data[this.txnSuccessRateChart.xAxis.data.length - 1];
        this.txnSuccessRateChart.series[0].markPoint = {
          data: [{ coord: [lastDate, res[lastDate]] }],
        };
        this.txnSuccessRateTitle.date = getChartDate(lastDate);
        this.txnSuccessRateTitle.data = `${(res[lastDate] * 100).toFixed(2)}%`;
        this.loadingTxnSuccessRate = false;
        this.isUpgrading = false;
      }).catch((err) => {
        this.loadingTxnSuccessRate = false;
        if (err.respCode === '11000') {
          this.isUpgrading = true;
        } else {
          this.isUpgrading = false;
        }
      });
    },
    changeMobileTab(tab) {
      this.mobileChart.tab = tab;
      this.mobileChart.subTab = 1;
    },
    changeMobileSubTab(tab) {
      this.mobileChart.subTab = tab;
    },
    async fetchRefuseRateData() {
      try {
        const res = await getRateInfoData({
          type: '1',
          currency: this.refuseCurrency,
        });
        this.refuseRateMap = res || {};
        const dates = Object.keys(res);
        this.refuseRateChart.xAxis.data = dates;

        const lastDate = dates[dates.length - 1];
        this.refuseRateChart.series[0].markPoint = { data: [{ coord: [lastDate, res[lastDate].rate] }] };

        this.refuseRateTitle.date = lastDate;
        this.refuseRateTitle.data = `${(res[lastDate].rate * 100).toFixed(2)}%`;
        this.refuseRateTitle.count = this.refuseRateMap[lastDate] ? this.refuseRateMap[lastDate].count : 0;

        const refuseRateData = [];
        for (let i = 0; i < dates.length; i++) {
          const item = res[dates[i]];
          refuseRateData.push(item.rate);
        }
        this.refuseRateChart.series[0].data = refuseRateData;
      } catch (err) {
        //
      }
    },
    async fetchRefundRateData() {
      try {
        const res = await getRateInfoData({
          type: '2',
          currency: this.refuseCurrency,
        });
        this.refundRateMap = res || {};
        const dates = Object.keys(res);
        this.refundRateChart.xAxis.data = dates;

        const lastDate = dates[dates.length - 1];
        this.refundRateChart.series[0].markPoint = { data: [{ coord: [lastDate, res[lastDate].rate] }] };

        this.refundRateTitle.date = lastDate;
        this.refundRateTitle.data = `${(res[lastDate].rate * 100).toFixed(2)}%`;
        this.refundRateTitle.count = this.refundRateMap[lastDate] ? this.refundRateMap[lastDate].amount : 0;

        const refundRateData = [];
        for (let i = 0; i < dates.length; i++) {
          const item = res[dates[i]];
          refundRateData.push(item.rate);
        }
        this.refundRateChart.series[0].data = refundRateData;
      } catch (err) {
        //
      }
    },
    async changeRefuseChartData() {
      this.loadingRefuse = true;
      try {
        await Promise.all([this.fetchRefuseRateData(), this.fetchRefundRateData()]);
      } catch (err) {
        //
      }
      this.loadingRefuse = false;
    },
    refuseRateChartClickHandler(data) {
      this.refuseRateChart.series[0].markPoint.data = [{ coord: [data.name, data.value] }];
      this.refuseRateChart.series[0].data = [...this.refuseRateChart.series[0].data]; // 触发表单刷新
      this.refuseRateTitle.date = data.name;
      this.refuseRateTitle.data = `${(data.value * 100).toFixed(2)}%`;
      this.refuseRateTitle.count = this.refuseRateMap[data.name] ? this.refuseRateMap[data.name].count : 0;
    },
    refundRateChartClickHandler(data) {
      this.refundRateChart.series[0].markPoint.data = [{ coord: [data.name, data.value] }];
      this.refundRateChart.series[0].data = [...this.refundRateChart.series[0].data]; // 触发表单刷新
      this.refundRateTitle.date = data.name;
      this.refundRateTitle.data = `${(data.value * 100).toFixed(2)}%`;
      this.refundRateTitle.count = this.refundRateMap[data.name] ? this.refundRateMap[data.name].amount : 0;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.balance-wrapper {
  margin-bottom: 38px;
  display: inline-block;
  width: calc(100% - 275px);
  .balance-title-wrapper {
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
    align-items: center;
    .title {
      font-size: 26px;
      font-family: Avenir-Heavy, Avenir;
      font-weight: 800;
      line-height: 36px;
    }
    .buttons {
      .iconfont {
        font-size: 12px;
        transform: scale(0.67);
        &.prev {
          transform: scale(0.67) rotate(180deg);
        }
      }
    }
  }
  .balance-list {
    width: 100%;
    overflow: hidden;
    transition: all 0.5s ease-in;
    white-space: nowrap;
    position: relative;
    height: 165px;
    .balance-item {
      display: inline-block;
      min-width: 205px;
      height: 166px;
      background-color: $color-balance-bg;
      border-radius: 8px;
      padding: 18px 20px;
      box-sizing: border-box;
      margin-right: 15px;
      transition: all 0.5s ease-in;
      cursor: pointer;
      &:hover {
        background-color: #EEF9FF;
      }
      // &.active {
      //   background-color: #EEF9FF;
      // }
      .currency-img {
        height: 35px;
        width: 33px;
        display: block;
      }
      .amount {
        font-size: 26px;
        font-weight: 800;
        line-height: 36px;
        margin-top: 30px;
      }
      .currency-name {
        font-size: 14px;
        font-weight: 500;
        line-height: 19px;
        margin-top: 4px;
      }
    }
    &.mobile {
      display: none;
    }
  }
}
.summary-amount-wrapper {
  width: 260px;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;
  &.pc {
    float: right;
  }
  &.mobile {
    display: none;
  }
  .title {
    font-size: 26px;
    font-weight: bold;
    line-height: 36px;
    padding-bottom: 10px;
  }
  .content {
    background-color: $color-balance-bg;
    border-radius: 8px;
    padding: 13px 10px 24px;
    height: 166px;
    box-sizing: border-box;
    .time {
      font-size: 14px;
      font-weight: 500;
      line-height: 19px;
    }
    .currency {
      display: block;
    }
    .amount {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      vertical-align: top;
      label {
        font-size: 14px;
        margin-right: 5px;
        .i-popover {
          color: #43618A;
          opacity: 0.7;
        }
      }
    }
  }
}
.summary-wrapper {
  display: flex;
  justify-content: space-between;
  &.mobile {
    display: none;
  }
  .title {
    font-size: 26px;
    font-weight: 800;
    line-height: 37px;
    margin-bottom: 20px;
  }
  .content {
    height: 250px;
    // background-color: $color-balance-bg;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    .rate-today {
      padding: 20px;
      .title {
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
      }
      .data-wrapper {
        background-color: $color-white;
        text-align: center;
        padding: 20px 0 30px;
        margin-top: 40px;
        .rate {
          font-size: 26px;
          font-weight: 800;
          color: $color-primary;
          line-height: 36px;
          text-align: center;
          padding: 0 35px 7px;
          border-bottom: 4px solid #B2E2F4;;
          display: inline-block;
        }
      }
      .today-text {
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        margin-top: 24px;
        text-align: right;
      }
    }
    .overview-subtitle {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .data {
        font-size: 16px;
        font-weight: 800;
        color: $color-primary;
      }

      .date {
        font-size: 12px;
        font-weight: 400;
        color: $color-chart-date;
      }
    }
  }
  .summary-item {
    margin-right: 15px;
    flex: 1;
    .content {
      padding: 0;
      .overview-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .currency {
          width: 75px;
          ::v-deep .el-input__inner {
            background-color: $color-txn-currency-bg;
          }
        }

        .right {
          color: #264373;
          font-weight: 600;
          font-size: 14px;
        }
      }
    }
    .title {
      display: flex;
      align-items: center;
    }
  }
  .attention-item {
    flex: 1;
    .tip {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 3px;
    }
    .tip-list {
      .tip-item {
        cursor: pointer;
        padding: 18px 18px;
        background-color: $color-white;
        font-size: 16px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #264373;
        line-height: 22px;
        margin-top: 17px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tip-content {
          white-space: nowrap;
        }
        .right-wrapper {
          display: flex;
          align-items: center;
        }
        .icon-warning {
          color: $color-icon-warn;
          font-size: 26px;
          margin-right: 15px;
        }
        .count {
          font-size: 16px;
          font-weight: 800;
          line-height: 22px;
          margin-right: 20px;
        }
        .icon-a-lujingcopybeifen2 {
          font-size: 12px;
          transform: scale(0.66);
          color: $color-text-default-button;
        }
      }
    }
  }
}
.txn-wrapper {
  &.mobile {
    display: none;
  }
  .title-wrapper {
    display: flex;
    align-items: center;
    padding-top: 38px;
    padding-bottom: 20px;
    .title-wrapper-right {
      display: flex;
      align-items: center;
    }
    .title {
      flex: 1;
      font-size: 26px;
      font-weight: 800;
      line-height: 37px;
      margin-right: 30px;
    }
    .currency {
      width: 87px;
      margin-right: 20px;
    }
    .time {
      width: 127px;
    }

    ::v-deep .el-select .el-input__inner {
      font-weight: bold;
      color: $color-text-primary;
    }
  }
  .chart-wrapper {
    .chart-box-wrapper {
      display: flex;
      align-items: center;

      .chart-item {
        flex: 1;
      }
    }
    .txn-title-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .i-popover {
        margin-left: 11px;
        color: #43618A;
        opacity: 0.7;
      }

      .right {
        color: $color-primary;
        font-weight: 800;
        font-size: 16px;
      }
    }
    .txn-subtitle-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .amount {
        font-size: 16px;
        font-weight: 800;
        color: $color-primary;
      }
      .date {
        font-size: 12px;
        font-weight: 400;
        color: $color-chart-date;
      }
      .value {
        font-weight: 400;
        color: $color-chart-date;
        font-size: 14px;
      }
    }
  }

  .interval-box {
    display: flex;
    align-items: center;
    height: 32px;
    background: $color-balance-bg;
    border-radius: 4px;

    .interval-item {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      cursor: pointer;
      height: 100%;
      font-weight: bold;
      color: $color-text-primary;

      &:nth-child(2) {
        border-left: 1px solid #E0E2E4;
        border-right: 1px solid #E0E2E4;
      }

      &.active {
        color: #00A0DD;
      }
    }
  }
}
.show-today {
  width: 127px;
  height: 32px;
  background: #F4F6F8;
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .icon-eye {
    color: $color-primary;
  }
}
.entrance-wrapper {
  margin-top: 44px;
  .title {
    font-size: 26px;
    font-weight: 800;
    line-height: 36px;
  }
  .content-list {
    display: flex;
    flex-wrap: wrap;
    .content-item  {
      width: 230px;
      height: 170px;
      background-color: $color-balance-bg;
      margin-right: 15px;
      padding: 19px 15px 20px;
      box-sizing: border-box;
      margin-top: 15px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .icon-img {
        width: 56px;
        margin-left: 8px;
      }
      .text {
        font-size: 18px;
        font-weight: 800;
        line-height: 25px;
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .balance-wrapper {
    margin-bottom: 15px;
    width: 100%;
    .balance-title-wrapper {
      .title {
        font-size: 20px;
      }
      .buttons {
        display: none;
      }
    }
    .balance-list {
      height: 120px;
      overflow: auto;
      &.pc {
        display: none;
      }
      &.mobile {
        display: block;
      }
      .balance-item {
        min-width: 180px;
        margin-right: 10px;
        height: 120px;
        padding: 14px 10px 10px;
        .amount {
          font-size: 20px;
          margin-top: 10px;
          line-height: 27px;
        }
        .currency-name {
          margin-top: 0;
          font-size: 14px;
          line-height: 19px;
        }
        .currency-img {
          width: 33px;
        }
      }
    }
  }
  .summary-amount-wrapper {
    &.pc {
      display: none;
    }
    &.mobile {
      display: block;
      background: #F4F6F8;
      padding: 10px 20px;
      width: 100vw;
      transform: translateX(-10px);
      .top {
        display: flex;
        align-items: center;
        .time {
          font-size: 16px;
          font-weight: 500;
          line-height: 28px;
          white-space: nowrap;
          margin-right: 20px;
        }
        .currency {
          width: 75px;
        }
      }
      .bottom {
        display: flex;
        align-items: center;
        margin-top: 10px;
        .amount {
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          label {
            font-size: 14px;
            margin-right: 10px;
            .i-popover {
              color: #43618A;
              opacity: 0.7;
            }
          }
          &:first-child {
            margin-right: 35px;
          }
        }
      }
    }
  }
  .summary-wrapper {
    .title {
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
      margin-bottom: 10px;
    }
    &.pc {
      display: none;
    }
    &.mobile {
      display: block;
      .content {
        box-shadow: 1px 2px 8px 1px #F6F8FA;
        border-radius: 12px;
        padding: 0;
        height: inherit;
        background: $color-balance-bg;
        .tip-list-mobile {
          display: flex;
          .tip-item {
            width: 50%;
            padding: 20px 15px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            &:first-child {
              border-right: 1px solid #D4D9E3;
            }
            .left-wrapper {
              .left-top {
                display: flex;
              }
              .iconfont {
                font-size: 36px;
                margin-right: 10px;
              }
              .icon-xingzhuangjiehe {
                color: #7C86D8;
              }
              .icon-xingzhuangjiehe2 {
                color: #EF9E8D;
              }
              .tip-content {
                font-size: 20px;
                font-weight: 600;
                line-height: 28px;
                margin-bottom: 4px;
                white-space: nowrap;
              }
              .tip-content-sub {
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                white-space: nowrap;
              }
              .bottom {
                margin-top: 29px;
                padding-left: 46px;
              }
              .count {
                font-size: 24px;
                font-weight: 600;
                line-height: 33px;
              }
              .unit {
                font-size: 14px;
                font-weight: 400;
                line-height: 33px;
                margin-left: 3px;
              }
            }
            .right-wrapper {
              .item {
                margin-right: 10px;
              }
              .icon-lujing {
                font-size: 20px;
                color: rgba(38, 67, 115, 0.6);
              }
            }
          }
        }
      }
    }
  }
  .txn-wrapper {
    &.pc {
      display: none;
    }
    &.mobile {
      display: block;
      margin-top: 35px;
      .title-wrapper {
        display: flex;
        padding-top: 15px;
        align-items: center;
        justify-content: space-between;
        .title {
          font-size: 20px;
          font-weight: 600;
          line-height: 34px;
        }
        .icon-eye {
          color: $color-primary;
        }
      }
      .tabs {
        border-radius: 10px;
        display: flex;
        .tab {
          width: 50%;
          height: 50px;
          font-size: 16px;
          font-weight: 600;
          line-height: 50px;
          text-align: center;
          background: #F4F6F8;
          color: #3E6EB0;
          &:first-child {
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
          }
          &:last-child {
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
          }
          &.active {
            color: #FFFFFF;
            background-color: #01A2DD;
          }
        }
      }
      .sub-tab-btns {
        text-align: center;
        margin-top: 15px;
        margin-bottom: 15px;
        .btn {
          padding-right: 15px;
          padding-left: 15px;
          color: #264373;
          &.active {
            color: #01A2DD;
          }
        }
      }
      .chart-box {
        background: #F4F6F8;
        box-shadow: 1px 2px 10px 2px rgba(233,233,233,0.5);
        border-radius: 12px;
        height: 320px;
        .txn-subtitle-wrapper {
          .date {
            font-size: 16px;
          }
        }
        .overview-title, .overview-subtitle {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }

      .chart-wrapper {
        .chart-item {
          box-shadow: 1px 2px 10px 2px rgba(233,233,233,0.5);
          border-radius: 12px;
          background-color: $color-balance-bg;
        }
      }
    }
  }
  .entrance-wrapper {
    .content-list {
      display: block;
      width: 100%;
      overflow: auto;
      white-space: nowrap;
      .content-item {
        width: 200px;
        height: 170px;
        margin-right: 10px;
        border-radius: 12px;
        display: inline-flex;
        .text {
          display: block;
        }
      }
    }
  }
}

.success-temporary{
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 38px;
  height: 100%;
}
</style>
